module.exports = __webpack_public_path__ + "img/img9.c22d187a.jpg";